import Modal, { ModalSize } from "~/common/components/Modal";
import { useAddToCartWizardContext } from "~/features/addToCart/components/AddToCartProcess/AddToCartWizard";
import AtcProductInfo from "~/features/addToCart/components/v2/AtcProductInfo/AtcProductInfo";
import { useFormContext } from "react-hook-form";
import { type AddToCartFormData } from "~/features/addToCart/hooks/useAddToCartNew";
import OptimeSolutionsMessage from "~/domains/optime/components/OptimeSolutionsMessage";
import { PackagingSelection } from "~/domains/product/components/PackagingSelection/PackagingSelection";
import { getCountriesListFromFifteendigit, isProductPMA } from "~/domains/product/utils/productDescriptorUtils";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import DisclaimerCountryOrigin from "~/domains/product/components/DisclaimerCountryOrigin";
import { AutosuggestPackageRestrictionContext } from "~/features/PackageRestriction/AutosuggestPackageRestrictionContext";
import { InfoProductMessagePMA } from "~/features/productDetails/components/ProductSummary/InfoProductMessagePMA";
import { Alert } from "~/common/mui/Alert/Alert";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";
import classNames from "classnames";
import AtcProductPriceInfo from "~/features/addToCart/components/v2/AtcProductPriceInfo/AtcProductPriceInfo";
import { useIsMinDesktopSize, useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

interface Props {
  productDescriptor: ProductDescriptor;
}

export const ConsumerViewAvailabilityModal = ({ productDescriptor }: Props) => {
  const { closePopup, getMainCls, t, getCloseBtn, restrictionQuery } = useAddToCartWizardContext();

  const isTablet = useIsMinTabletSize();
  const isDesktop = useIsMinDesktopSize();

  const { watch } = useFormContext<AddToCartFormData>();

  const quantity = watch("quantity");

  return (
    <AutosuggestPackageRestrictionContext productCode={productDescriptor.base.code} query={restrictionQuery}>
      <Modal
        size={isDesktop ? ModalSize.MEDIUM : ModalSize.TABLET}
        onClose={() => closePopup()}
        noPadding={!isTablet}
        modalClassName={"scha__add-to-cart-popup"}
        footerClassName={classNames(!isTablet && "scha__add-to-cart-popup-footer")}
        footerChildren={getCloseBtn(t("close"), !isTablet)}
      >
        <div className="scha__atc-popup__wrapper">
          <div className={classNames(getMainCls(), "scha__atc-popup-continer")}>
            <div className="scha__atc-product-info-wrapper">
              <AtcProductInfo descriptor={productDescriptor} />
            </div>
            <div className="scha__atc-popup--packaging-selection-notifications-wrapper">
              <div className="scha__atc-popup--column-packaging__wrapper scha__atc-popup--column-packaging">
                <div className="scha__atc-popup--column-packaging">
                  <div className="scha__atc-packaging-opts">
                    <div className="scha__atc-packaging-opts__title">{t("addToCartPopup.select.packaging.title")}</div>
                    <PackagingSelection selectedCode={""} product={productDescriptor} selectionType={"radio"} />
                  </div>
                </div>
                <AtcProductPriceInfo
                  quantity={null}
                  price={null}
                  onChange={() => {}}
                  priceUnit={1}
                  priceReference={""}
                  descriptor={productDescriptor}
                />
              </div>
              <div className="notifications scha__atc-popup--notifications">
                {isProductPMA(productDescriptor) && <InfoProductMessagePMA />}
                {userHasPermission(Permission.ADD_TO_CART) && (
                  <Alert severity="info" className="scha-atc__delivery-disclaimer">
                    {t("addToCartPopup.disclaimer")}
                  </Alert>
                )}
                {productDescriptor.base.isOptime && <OptimeSolutionsMessage />}
                {getCountriesListFromFifteendigit({ descriptor: productDescriptor }).length > 0 && (
                  <DisclaimerCountryOrigin />
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </AutosuggestPackageRestrictionContext>
  );
};
